<template>
  <div class="opage">
    <div>
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="feedbackList">
          <!-- 全部 -->
          <!-- <el-tab-pane :label="$t('message.all')" name="">
            </el-tab-pane> -->
          <!-- 待确认 -->
          <!--2023/03/2 数字先不放,需要后端给接口 -->
          <el-tab-pane :label="$t('message.toBeConfirmed')" name="1">
          </el-tab-pane>
          <!-- 已确认 -->
          <el-tab-pane :label="$t('message.confirmed')" name="2">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="table">
        <ol>
          <!-- 客户信息 -->
          <li>
            {{ $t("message.userInfo") }}
          </li>
          <!-- 对应人员 -->
          <li>
            {{ $t("message.correspondingPerson") }}
          </li>
          <!-- 页面链接 -->
          <li class="flex2">
            {{ $t("message.pageLink") }}
          </li>
          <!-- 提出时间 -->
          <li>
            {{ $t("message.forwardTime") }}
          </li>
          <!-- 问题描述 -->
          <li class="flex2">
            {{ $t("message.problemDescriptionMS") }}
          </li>
          <!-- 图片 -->
          <li class="imageLI">
            {{ $t("message.picture") }}
          </li>
          <!-- 处理备注 -->
          <li class="flex15">
            {{ $t("message.workWithNotes") }}
          </li>
          <!-- 确认状态（时间） -->
          <li>
            {{ $t("message.confirmTheStatus") }}({{ $t("message.times") }})
          </li>
        </ol>
        <ul v-for="(tableItem, tableIndex) in tableData" :key="tableIndex">
          <!-- 客户信息 -->
          <li>
            <div class="listShow">
              <p>{{ tableItem.user ? tableItem.user.id : '' }}</p>
              <p>{{ tableItem.user ? tableItem.user.realname : '' }}</p>
            </div>
          </li>
          <!-- 对应人员 -->
          <li>
            <div>
              <p>{{ tableItem.user && tableItem.user.y_admin ? tableItem.user.y_admin.realname : '' }}</p>
              <p>{{ tableItem.user && tableItem.user.g_admin ? tableItem.user.g_admin.realname : '' }}</p>
              <p>{{ tableItem.user && tableItem.user.p_admin ? tableItem.user.p_admin.realname : '' }}</p>
            </div>
          </li>
          <!-- 页面链接 -->
          <li class="flex2">
            <a class="a-link" :href="'https://www.rakumart.com' + tableItem.page_url" target="_blank">
              https://www.rakumart.com{{ tableItem.page_url }}
            </a>
          </li>
          <!-- 提出时间 -->
          <li>
            {{ tableItem.created_at }}
          </li>
          <!-- 问题描述 -->
          <li class="flex2">
            <div class="template" :title="tableItem.desc">
              {{ tableItem.desc }}
            </div>
          </li>
          <!-- 图片 -->
          <li class="imageLI">
            <div v-for="(imageItem, imageIndex) in tableItem.images" :key="imageIndex">
              <el-popover placement='right' trigger='hover'>
                <img :src='imageItem' alt='' style="width:300px; height:300px" />
                <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
              </el-popover>
            </div>
          </li>
          <!-- 处理备注 -->
          <li class="flex15">
            <span>{{ tableItem.confirm_remark }}</span>
          </li>
          <!-- 确认状态（时间） -->
          <li>
            <!-- 文本: 待确认 -->
            {{ tableItem.confirm_at ? tableItem.confirm_at : $t('message.toBeConfirmed') }}
          </li>
        </ul>
        <div v-if="tableData == false" class="No_data">暂无数据</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user_id: { type: Number }
  },
  data() {
    return {
      total: 0,
      num: 0,
      datas: {
        status: '1'
      },
      tableData: [],
    };
  },
  component: {},
  methods: {
    // 获取列表
    feedbackList() {
      this.datas.user_id = this.user_id
      this.tableData = []
      this.$api.JapaneseOffice.feedbackList(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.feedbackList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.feedbackList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {

  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
  word-break: break-all;

}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .imageLI {
    flex-wrap: wrap;
    flex: 0 0 100px;

    img {
      width: 36px;
      height: 36px;
      margin: 0 6px 6px 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;

    .template {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.listShow {
  text-align: center;
}
</style>